<template>
  <client-only>
    <v-container fluid class="py-0">
      <v-row align-content="center">
        <!-- Measure -->
        <v-col cols="4">
          <v-row>
            <v-col cols="12" class="py-0">
              <v-row>
                <v-col cols="1" class="py-0 px-0">
                  <v-tooltip
                    :open-on-click="true"
                    :open-on-hover="true"
                    bottom
                    color="#525867"
                    :max-width="$vuetify.breakpoint.xs ? '90%' : '33%'"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <img
                        v-bind="attrs"
                        v-on="on"
                        src="/employment_index/Qustion.png"
                        width="22px"
                        alt="info"
                        class="v-align-middle"
                      />
                    </template>

                    <span
                      class="display-18"
                      v-html="texts.Keys[3].KeyValue.Value"
                    >
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col class="py-0">
                  <p class="text-center avocado-font py-0">100%</p>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="d-flex py-0">
              <v-row class="progress-wrap">
                <img src="/img/meter.png" alt="chart" class="chart" />
                <img
                  src="/img/arrow.png"
                  alt="arrow"
                  class="arrow"
                  ref="Measure"
                />
              </v-row>
            </v-col>
            <v-col cols="12" class="pt-0">
              <p class="text-center white--text bold mb-0">{{ Measure }}%</p>
              <p class="text-center display-18-14 white--text mb-0 mt-n2">
                {{ texts.Keys[2].KeyValue.Value }}
              </p>
            </v-col>
          </v-row>
        </v-col>

        <!-- Supply -->
        <v-col cols="4">
          <v-row>
            <v-col cols="12" class="py-0"
              ><p class="text-center avocado-font py-0">100%</p>
            </v-col>
            <v-col cols="12" class="d-flex py-0">
              <v-row class="progress-wrap">
                <img src="/img/meter.png" alt="chart" class="chart" />
                <img
                  src="/img/arrow.png"
                  alt="arrow"
                  class="arrow"
                  ref="Supply"
                />
              </v-row>
            </v-col>
            <v-col cols="12" class="pt-0">
              <p class="text-center white--text bold mb-0">{{ Supply }}%</p>
              <p class="text-center display-18-14 white--text mb-0 mt-n2">
                {{ texts.Keys[1].KeyValue.Value }}
              </p>
            </v-col>
          </v-row>
        </v-col>

        <!-- Demand -->
        <v-col cols="4">
          <v-row>
            <v-col cols="12" class="py-0"
              ><p class="text-center avocado-font py-0">100%</p>
            </v-col>
            <v-col cols="12" class="d-flex py-0">
              <v-row class="progress-wrap">
                <img src="/img/meter.png" alt="chart" class="chart" />
                <img
                  src="/img/arrow.png"
                  alt="arrow"
                  class="arrow"
                  ref="Demand"
                />
              </v-row>
            </v-col>
            <v-col cols="12" class="pt-0">
              <span class="text-center white--text bold mb-0 d-block"
                >{{ Demand }}%</span
              >
              <span
                class="text-center display-18-14 white--text mb-0 mt-n2 d-block"
              >
                {{ texts.Keys[0].KeyValue.Value }}
              </span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </client-only>
</template>
    
<script>
export default {
  data() {
    return {
      initialArrowDegrees: 260,
    }
  },

  props: {
    Demand: {
      type: Number,
      required: false,
      default: 0,
    },
    Supply: {
      type: Number,
      required: false,
      default: 0,
    },
    Measure: {
      type: Number,
      required: false,
      default: 0,
    },
    texts: Object,
  },

  methods: {
    rotate() {
      /** @param {number} initialArrowDegrees - Start position  , 300deg from left side */
      /** Todo - check Arrow's position with real Values */

      this.$nextTick(() => {
        this.$refs.Demand.style.transform = `rotate(${
          this.initialArrowDegrees + this.Demand
        }deg)  translate3d(0, 0, 0)`
        this.$refs.Measure.style.transform = `rotate(${
          this.initialArrowDegrees + this.Measure
        }deg)  translate3d(0, 0, 0)`
        this.$refs.Supply.style.transform = `rotate(${
          this.initialArrowDegrees + this.Supply
        }deg)  translate3d(0, 0, 0)`
      })
    },
  },

  mounted() {
    this.rotate()
  },
}
</script>

<style lang="scss" scoped>
.progress-wrap {
  position: relative;
  left: 0;
  top: 0;
  height: 55px;
}
.chart {
  height: auto;
  width: auto;
  max-width: 80px;
  max-height: 50px;
  margin: 0 auto;
}
.arrow {
  position: absolute;
  top: 5%;
  left: 0%;
  right: 0;
  margin: 0 auto;
  z-index: 2;
  width: 15px;
  transform: rotate(260deg);
  transform-origin: bottom center;
  backface-visibility: hidden;

  @keyframes spin {
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
.avocado-font {
  color: #acc464;
  font-size: 12px;
}
@media only screen and (min-width: 1500px) {
  .progress-wrap {
    height: 100px;
  }
  .chart {
    width: auto;
    height: auto;
    max-width: 160px;
    max-height: 90px;
  }
  .arrow {
    width: auto;
    top: 10%;
  }
  .avocado-font {
    color: #acc464;
    font-size: 13px;
  }
}
</style>